import { render, staticRenderFns } from "./activity-info.vue?vue&type=template&id=95a21320&"
import script from "./activity-info.vue?vue&type=script&lang=js&"
export * from "./activity-info.vue?vue&type=script&lang=js&"
import style0 from "./activity-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports